// Şube Firma Bilgileri penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'branches.companyDetails';

export const branchCompanyDetailsGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Şube firma bilgileri nasıl girilir?'),
  intro: t(`${G}.intro`, 'Bu şubenin resmi firma bilgilerini (unvan, vergi, sicil, adres ve iletişim) kaydedersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve şube adı'),
    body: t(`${G}.regions.body`, 'Firma bilgisi alanları'),
    footer: t(`${G}.regions.footer`, 'İptal / Kaydet'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu bilgiler nerede kullanılır?'),
      text: t(`${G}.s1.text`, 'Başlığın altında hangi şubenin bilgilerini düzenlediğiniz yazar. Bu şube Şubeler sayfasında "Franchise" olarak işaretliyse, buradaki firma bilgileri kesilen fatura ve yazdırılan fişlerde satıcı bilgisi olarak görünür. Franchise değilse ana firma bilgileri (Şirket Bilgileri) kullanılır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Franchise işaretini bu pencereden değil, Şubeler sayfasındaki şube ekleme / düzenleme penceresinden açıp kapatırsınız.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Firma adı ve vergi bilgileri'),
      text: t(`${G}.s2.text`, '"Firma Adı" alanına şubeyi işleten firmanın resmi unvanını yazın. "Vergi Numarası / T.C. Kimlik No" ve "Vergi Dairesi" alanlarını vergi levhasındaki gibi doldurun.'),
      tips: [
        t(`${G}.s2.tip1`, 'Şahıs işletmesinde vergi numarası yerine T.C. kimlik numarası yazılabilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Ticaret Sicil No ve Mersis No'),
      text: t(`${G}.s3.text`, 'Firmanın ticaret sicil numarasını ve Mersis numarasını resmi belgelerinizdeki gibi girin. Bilmiyorsanız boş bırakabilirsiniz.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Adres ve iletişim'),
      text: t(`${G}.s4.text`, '"Adres" alanına firmanın açık adresini, ardından Telefon, E-posta ve Web Sitesi bilgilerini yazın. Web sitesini https://www.ornek.com biçiminde girin.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin'),
      text: t(`${G}.s5.text`, '"Kaydet" bilgileri şubeye yazar; "Firma bilgileri başarıyla kaydedildi." mesajından sonra pencere kendiliğinden kapanır. "İptal" değişiklikleri kaydetmeden kapatır.'),
      tips: [
        t(`${G}.s5.tip1`, 'Hiçbir alan zorunlu değildir. Bir alanı boşaltıp kaydederseniz o bilgi silinir.'),
        t(`${G}.s5.tip2`, 'Şubenin logo ve kaşesi bu pencereden değişmez.'),
      ],
    },
  ],
});
